import React from 'react';
import { withCitrusTheme } from '@gousto-internal/citrus-react';
import {
  AVAILABILITY_NEGATIVE_COLOUR,
  AVAILABILITY_YES_COLOUR,
  COMPARISON_TABLE_BREAKPOINT,
} from './tokens';
import type { AvailabilityState } from './comparisonTypes';

export { AVAILABILITY_YES_COLOUR, AVAILABILITY_NEGATIVE_COLOUR };

const DESKTOP = `@media (min-width: ${COMPARISON_TABLE_BREAKPOINT})`;

// Disc sizes match the UK CWC table: 30px mobile → 38px desktop (glyph scales with it).
const Circle = withCitrusTheme('span', () => ({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '30px',
  height: '30px',
  borderRadius: '50%',
  '& svg': { width: '15px', height: '15px' },
  [DESKTOP]: {
    width: '38px',
    height: '38px',
    '& svg': { width: '19px', height: '19px' },
  },
}));

function circleColour(state: AvailabilityState): string {
  return state === 'yes' ? AVAILABILITY_YES_COLOUR : AVAILABILITY_NEGATIVE_COLOUR;
}

function TickIcon(): JSX.Element {
  return (
    <svg
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
      aria-hidden="true"
      focusable="false"
    >
      <path
        d="M4 10l4 4 7-8"
        stroke="#fff"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function CrossIcon(): JSX.Element {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M4 4l9 9M13 4l-9 9" stroke="#fff" strokeWidth="2.5" strokeLinecap="round" />
    </svg>
  );
}

function DashIcon(): JSX.Element {
  return (
    <svg
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M4 9.5h11" stroke="#fff" strokeWidth="2.5" strokeLinecap="round" />
    </svg>
  );
}

function Glyph({ state }: { state: AvailabilityState }): JSX.Element {
  if (state === 'yes') {
    return <TickIcon />;
  }
  if (state === 'no') {
    return <CrossIcon />;
  }
  return <DashIcon />;
}

export function AvailabilityIcon({ state }: { state: AvailabilityState }): JSX.Element {
  return (
    <Circle style={{ backgroundColor: circleColour(state) }}>
      <Glyph state={state} />
    </Circle>
  );
}
